import styled from "styled-components";

export const DivMarginLeft = styled.div<{ ml: number }>`
  margin-left: ${(props) => props.ml}rem;
`;
